import { Table, TableCell, TableFooter, TableRow } from '@mui/material'
import { styled, SxProps } from '@mui/system'

export const StyledEmployeeMonthlyHoursTable = styled(Table)(({ theme }) => ({
  borderCollapse: 'separate',
  '& .MuiTableCell-root:not(:last-child)': {
    borderRight: `1px solid`,
    borderColor: theme.palette.background.elevation8,
  },
}))

export const StyledEmployeeMonthlyHoursFooter = styled(TableFooter)(({ theme }) => ({
  '& .MuiTypography-root': {
    fontWeight: 500,
    color: theme.palette.text.base,
  },
}))

export const StyledEmployeeMonthlyHoursFooterCell = styled(TableCell)(({ theme }) => ({
  paddingTop: '8px',
  paddingBottom: '8px',
  borderTop: '3px solid',
  borderTopColor: theme.palette.background.elevation8,
  borderBottom: '0px',
  color: theme.palette.text.base,
  backgroundColor: theme.palette.background.elevation1,
}))

export const StyledEmployeeMonthlyHoursHeaderCell = styled(TableCell)(({ theme }) => ({
  width: '95px !important',
  minWidth: '95px !important',
  maxWidth: '95px !important',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  backgroundColor: theme.palette.background.elevation2,
  borderBottom: '3px solid',
  borderBottomColor: theme.palette.background.elevation8,
  color: theme.palette.text.base,
}))

export const StyledEmployeeMonthlyHoursCheckboxCell = styled(TableCell)(({ theme }) => ({
  width: '95px !important',
  minWidth: '95px !important',
  maxWidth: '95px !important',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  backgroundColor: theme.palette.background.elevation2,
  borderBottom: '0px',
  paddingBottom: '0px !important',
  color: theme.palette.text.base,
}))

export const StyledEmployeeMonthlyHoursTableRow = styled(TableRow)(({ theme }) => ({
  color: theme.palette.text.base,
  backgroundColor: theme.palette.background.main,
  '&:hover': {
    backgroundColor: theme.palette.background.elevation3,
  },
  '&.holiday': {
    '&:not(.Mui-selected)': {
      color: theme.palette.accent.orange.text,
      svg: {
        color: theme.palette.accent.orange.text,
      },
      '&:hover': {
        color: theme.palette.accent.orange.textHover,
        svg: {
          color: theme.palette.accent.orange.textHover,
        },
      },
    },
  },
  '&.weekend': {
    '&:not(.Mui-selected)': {
      backgroundColor: theme.palette.background.elevation2,
      '&:hover': {
        backgroundColor: theme.palette.background.elevation3,
      },
    },
  },
  '&.holiday-weekend': {
    '&:not(.Mui-selected)': {
      color: theme.palette.accent.orange.text,
      backgroundColor: theme.palette.background.elevation2,
      svg: {
        color: theme.palette.accent.orange.text,
      },
      '&:hover': {
        color: theme.palette.accent.orange.textHover,
        backgroundColor: theme.palette.background.elevation3,
        svg: {
          color: theme.palette.accent.orange.textHover,
        },
      },
    },
  },
}))

export const stickyStyles: SxProps = { position: 'sticky', zIndex: 10 }
